import { useEffect, useState } from 'react';
import { useSurveyIfEnabled } from '../hooks/useSurveyIfEnabled';
import { SurveyName } from '../surveysUuidMap';
import { discoveryCallSurveyBlockersSelector } from './blockersSelectors';
import { getDiscoveryCallSurveyBlockersFromSurvey } from './dialogBlockers';
import { DiscoveryCallSurveyDialog } from './dialogs/DiscoveryCallSurveyDialog';
import { DiscoveryCall } from './discoveryCallsList';

const SURVEY_NAME = 'discoveryCallSurvey' satisfies SurveyName;

const DiscoveryCallSurvey = ({
  discoveryCall,
  blockersSelector = discoveryCallSurveyBlockersSelector,
  calendlyLink,
}: {
  discoveryCall: DiscoveryCall;
  blockersSelector?: Parameters<
    typeof useSurveyIfEnabled
  >[0]['blockersSelector'];
  calendlyLink: string;
}) => {
  const [userEngaged, setUserEngaged] = useState(false);

  const surveyInfo = useSurveyIfEnabled({
    surveyName: SURVEY_NAME,
    userEngaged,
    blockersSelector,
    getBlockersFromSurvey: getDiscoveryCallSurveyBlockersFromSurvey,
  });

  // we have sufficient engagement for survey feedback after 10s spent w/ this component rendered
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setUserEngaged(true);
    }, 10 * 1000);
    return () => {
      clearTimeout(timeoutId);
    };
  }, []);

  return (
    <>
      {surveyInfo.survey && (
        <DiscoveryCallSurveyDialog
          open={surveyInfo.shouldViewSurvey}
          survey={surveyInfo.survey}
          discoveryCall={discoveryCall}
          calendlyLink={calendlyLink}
        />
      )}
    </>
  );
};

export { DiscoveryCallSurvey };
